import script from "./ParticipantsTableAdminIsolate.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantsTableAdminIsolate.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantsTableAdminIsolate.vue?vue&type=style&index=0&id=7b91a494&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b91a494"]])

export default __exports__